import { render, staticRenderFns } from "./LogoutPage.vue?vue&type=template&id=56c0a3cd"
import script from "../js/components/Logout.js?vue&type=script&lang=js&external"
export * from "../js/components/Logout.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports